import { msg } from "@lingui/core/macro";

export const globalLocationCapacityRuleMessages = {
	name: msg({ message: "Global Location Capacity" }),
	description: msg({
		message: "Limits the number of permits that can be active at a time at a location, across all permit types",
	}),
	errors: {
		locationFull: msg({
			comment:
				"Error shown when a permit request is rejected because the location has reached its configured capacity. {location} is the location's name, {amount} the configured limit.",
			message:
				"{location} has reached its active permit limit of {amount} for the selected time. Try a different time or adjust the permit details.",
		}),
	},
} as const;
